module.exports = __webpack_public_path__ + "img/首图背景.22ab9fae.png";